import config from '../../config';

export default {
  computed: {
    discountActive() {
      return !!(this.isPartner ? this.productInfo.prices.partner.discountPercentage : this.productInfo.prices.customer.discountPercentage);
    },
    discountImage() {
      const percentage = this.isPartner ? this.productInfo.prices.partner.discountPercentage : this.productInfo.prices.customer.discountPercentage;
      const { availableDiscounts } = config.products;

      if(availableDiscounts.indexOf(percentage) >= 0) {
        return config.products.images[percentage];
      }
      return ``;
    },
    showFirstTimeBuyer() {
      if(this.isPartner) {
        // return the price only if initialPurchase price is different to the regular price
        if(this.productInfo.prices.partner.initialPurchase.brutto !== this.productInfo.prices.partner.brutto) {
          return this.productInfo.prices.partner.initialPurchase.brutto;
        }
        return false;
      }
      // return the price only if initialPurchase price is different to the regular price
      if(this.productInfo.prices.customer.initialPurchase.brutto !== this.productInfo.prices.customer.brutto) {
        return this.productInfo.prices.customer.initialPurchase.brutto;
      }
      return false;
    },
    soldOutImage() {
      return config.products.images.soldOut;
    },
  },
};
